import { createSlice } from '@reduxjs/toolkit';

import { receivedIndiaBoxes, getIndiaQCInspection, indiaUploadRemarks, indiaGetRemarks, verifyIndiaQcInspection, createIndiaPO, updateAttributes, getAttributes, uploadStyleSurveyDesignFile, downloadStyleSurveyFile } from '../../apis';

export const IndiaQCPlatform = createSlice({

    name: 'indiaStyleSurvey',
    initialState: {
        loading: false,
        error: '',
        data: [],
        downloadSurveyRequestSuccess: false,
        uploadSurveyRequestSuccess: false
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(downloadStyleSurveyFile.pending, (state, action) => {
            state.loading = true;
            state.downloadSurveyRequestSuccess = false
        })
        builder.addCase(downloadStyleSurveyFile.fulfilled, (state, action) => {
            state.loading = false;
            state.downloadSurveyRequestSuccess = action.payload.message || true
        })
        builder.addCase(downloadStyleSurveyFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadStyleSurveyDesignFile.pending, (state, action) => {
            state.loading = true;
            state.uploadSurveyRequestSuccess = false
        })
        builder.addCase(uploadStyleSurveyDesignFile.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadSurveyRequestSuccess = action.payload.message || true
        })
        builder.addCase(uploadStyleSurveyDesignFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
    }
})

export const { clearError, clear } = IndiaQCPlatform.actions

export default IndiaQCPlatform.reducer